var styles = {
  "Masthead--sticky": "pb-Masthead__Masthead--sticky",
  "wrapper": "pb-Masthead__wrapper",
  "wrapper--sticky": "pb-Masthead__wrapper--sticky",
  "wrapper--scrolled": "pb-Masthead__wrapper--scrolled",
  "container": "pb-Masthead__container"
};
export default styles;